











import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "MassMessageConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    loading: { type: Boolean },
    show: { type: Boolean },
  },
});
